<div class="form-group">
  <label for="code" class="col-sm-2 control-label">Code</label>
  <div class="col-sm-10">
    <input type="text" class="form-control" name="code" id="code" placeholder="Domain Code"
           [(ngModel)]="financialAccount.code"
           required>
  </div>
</div>

<div class="form-group">
  <label for="name" class="col-sm-2 control-label">Name</label>
  <div class="col-sm-10">
    <input type="text" class="form-control" name="name" id="name" placeholder="Financial Accounts Name"
           [(ngModel)]="financialAccount.name" required>
  </div>
</div>

<div class="form-group">
  <label for="description" class="col-sm-2 control-label">Description</label>
  <div class="col-sm-10">
    <textarea class="form-control" name="description" id="description" placeholder="Description"
              [(ngModel)]="financialAccount.description"></textarea>
  </div>
</div>

<div class="form-group">
  <div class="col-sm-offset-2 col-sm-10 text-right">
    <button type="submit" class="btn btn-success">Save</button>
  </div>
</div>
